/* eslint-disable import/first */

// initialize newrelic before anything else
// eslint-disable-next-line import/order
import newrelic from "./newrelic"

newrelic?.run()

import React from "react"

import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev"
import ReactDOM from "react-dom/client"

import { isDevEnv, isTestEnv } from "@helpers/isProductionEnv"

import App from "./App"

import "@fontsource/inter/latin-100.css"
import "@fontsource/inter/latin-200.css"
import "@fontsource/inter/latin-300.css"
import "@fontsource/inter/latin-400.css"
import "@fontsource/inter/latin-500.css"
import "@fontsource/inter/latin-600.css"
import "@fontsource/inter/latin-700.css"
import "@fontsource/inter/latin-800.css"
import "@fontsource/inter/latin-900.css"

declare global {
  interface Window {
    version: string
  }
}
declare const COMMIT_HASH: string
window.version = COMMIT_HASH

/* eslint-enable import/first */
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

if (isDevEnv() || isTestEnv()) {
  loadDevMessages()
  loadErrorMessages()
}

async function startMockWorkderIfEnabled() {
  if (import.meta.env.ENABLE_MSW) {
    const { worker } = await import("./mocks/worker")

    return worker.start({ onUnhandledRequest: "bypass" })
  }

  return Promise.resolve()
}

startMockWorkderIfEnabled().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})
